// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"82":"3e08dbcf57d39760f5e9","932":"45f0c61cd0133a04ae5e"}[chunkId] + ".css";
};